module.exports = __webpack_public_path__ + "media/images/icons/calendar-a502f2b9aa9fa1a076251ff51bacf9fc.svg";